/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReferralRelationship } from './ReferralRelationship';
import {
    ReferralRelationshipFromJSON,
    ReferralRelationshipFromJSONTyped,
    ReferralRelationshipToJSON,
    ReferralRelationshipToJSONTyped,
} from './ReferralRelationship';
import type { RelationshipType } from './RelationshipType';
import {
    RelationshipTypeFromJSON,
    RelationshipTypeFromJSONTyped,
    RelationshipTypeToJSON,
    RelationshipTypeToJSONTyped,
} from './RelationshipType';

/**
 * 
 * @export
 * @interface ReferredUserData
 */
export interface ReferredUserData {
    /**
     * 
     * @type {string}
     * @memberof ReferredUserData
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof ReferredUserData
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof ReferredUserData
     */
    email: string;
    /**
     * 
     * @type {number}
     * @memberof ReferredUserData
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof ReferredUserData
     */
    userCreatedAt: number;
    /**
     * 
     * @type {string}
     * @memberof ReferredUserData
     */
    referralId: string;
    /**
     * 
     * @type {boolean}
     * @memberof ReferredUserData
     */
    isFirstReferral: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReferredUserData
     */
    isRegistrationReferral: boolean;
    /**
     * 
     * @type {RelationshipType}
     * @memberof ReferredUserData
     */
    relationshipType?: RelationshipType;
    /**
     * 
     * @type {Array<ReferralRelationship>}
     * @memberof ReferredUserData
     */
    referralHistory: Array<ReferralRelationship>;
}



/**
 * Check if a given object implements the ReferredUserData interface.
 */
export function instanceOfReferredUserData(value: object): value is ReferredUserData {
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('userCreatedAt' in value) || value['userCreatedAt'] === undefined) return false;
    if (!('referralId' in value) || value['referralId'] === undefined) return false;
    if (!('isFirstReferral' in value) || value['isFirstReferral'] === undefined) return false;
    if (!('isRegistrationReferral' in value) || value['isRegistrationReferral'] === undefined) return false;
    if (!('referralHistory' in value) || value['referralHistory'] === undefined) return false;
    return true;
}

export function ReferredUserDataFromJSON(json: any): ReferredUserData {
    return ReferredUserDataFromJSONTyped(json, false);
}

export function ReferredUserDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferredUserData {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'email': json['email'],
        'createdAt': json['createdAt'],
        'userCreatedAt': json['userCreatedAt'],
        'referralId': json['referralId'],
        'isFirstReferral': json['isFirstReferral'],
        'isRegistrationReferral': json['isRegistrationReferral'],
        'relationshipType': json['relationshipType'] == null ? undefined : RelationshipTypeFromJSON(json['relationshipType']),
        'referralHistory': ((json['referralHistory'] as Array<any>).map(ReferralRelationshipFromJSON)),
    };
}

export function ReferredUserDataToJSON(json: any): ReferredUserData {
    return ReferredUserDataToJSONTyped(json, false);
}

export function ReferredUserDataToJSONTyped(value?: ReferredUserData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'createdAt': value['createdAt'],
        'userCreatedAt': value['userCreatedAt'],
        'referralId': value['referralId'],
        'isFirstReferral': value['isFirstReferral'],
        'isRegistrationReferral': value['isRegistrationReferral'],
        'relationshipType': RelationshipTypeToJSON(value['relationshipType']),
        'referralHistory': ((value['referralHistory'] as Array<any>).map(ReferralRelationshipToJSON)),
    };
}

